import { ClientInformation } from './client-information';
import { IntegrationJavaScript } from './integration-javascript';
import { IntegrationRunTime } from './integration-runtime';
import { IntegrationInformation } from './integration-information';

export class Integration {

  constructor(i?: IntegrationInformation) {
    this.integrationId = i?.integrationId;
    this.clientId = i?.clientId;
    this.clientName = i?.clientName;
    this.dataSourceTypeId = i?.dataSourceType;
    this.name = i?.integrationName;
    this.locked = i?.locked;
    this.lockReason = i?.lockReason;
    this.serverId = i?.serverId;
    this.errorRetentionDays = i?.errorRetentionDays;
    this.selfHosted = i?.selfHosted;
    this.updatedDate = i?.integrationUpdatedDate;
    this.initialCreationDate = i?.integrationCreationDate;
  }

  clientId: number;
  clientInformationId?: string;
  clientName: string;
  integrationId: string;
  name: string;
  dataSourceTypeId: string;
  xmlConfig?: string;
  javaScript?: IntegrationJavaScript[];
  updatedDate: Date;
  initialCreationDate: Date;
  locked: boolean;
  lockReason: string;
  serverId: string;
  ipRestricted: boolean;
  integrationTypesAgg?: string;
  deleted?: boolean;
  errorRetentionDays: number;
  selfHosted: boolean;

  //runTimes?: RunTime[];
  client?: ClientInformation;
  integrationRunTimes?: IntegrationRunTime[];

  clientContractIds?: string[];
}

export class IntegrationResponseMessage {
  integrationId: string;
  message: string;
  status: string;
}

export class IntegrationFlags {
  deleted?: boolean;
  locked?: boolean;
  serverId?: string;
}

export const LockReasons = [
  'TEMP: Temporarily Locking',
  'TEMP: Resolving Issue',
  'TEMP: Investigating Issue',
  'TEMP: Addressing Ticket',
  'TEMP: Updating Runtime',
  'TEMP: Server Maintenance',
  'Client Canceled Contract',
  'Test Integration',
  'Replacing Integration',
  'Custom',
];